/**
 * Oblique Dynamic Filter Registry
 * Defines page-specific filter schemas to ensure context-aware data exploration.
 */

export const FILTER_REGISTRY = {
  'deal-audits': {
    title: 'Deal Audits',
    filters: [
      { id: 'result', label: 'Outcome', type: 'select', options: ['Pass', 'Fail', 'Pending'] },
      { id: 'auditor', label: 'Auditor', type: 'text', placeholder: 'Search auditor...' },
      { id: 'value', label: 'Deal Value', type: 'range', min: 0, max: 100000 },
      { id: 'region', label: 'Region', type: 'select', options: ['North America', 'Europe', 'APAC', 'LATAM'] }
    ]
  },
  'leads': {
    title: 'Leads',
    filters: [
      { id: 'status', label: 'Status', type: 'select', options: ['New', 'Contacted', 'Qualified', 'Unqualified'] },
      { id: 'source', label: 'Source', type: 'select', options: ['Google', 'LinkedIn', 'Referral', 'Outbound'] },
      { id: 'industry', label: 'Industry', type: 'text', placeholder: 'Filter by industry...' },
      { id: 'owner', label: 'Owner', type: 'text', placeholder: 'Filter by owner...' }
    ]
  },
  'orders': {
    title: 'Orders',
    filters: [
      { id: 'status', label: 'Payment Status', type: 'select', options: ['Paid', 'Pending', 'Failed', 'Refunded'] },
      { id: 'amount', label: 'Order Total', type: 'range', min: 0, max: 50000 },
      { id: 'type', label: 'Product Type', type: 'select', options: ['Subscription', 'One-time', 'Service'] }
    ]
  },
  'hubspot-tracker': {
    title: 'HubSpot Audit',
    filters: [
      { id: 'leadStatus', label: 'Lead Status', type: 'select', options: ['New', 'Open', 'In Progress', 'Connected', 'Bad Timing', 'Contact Established'] },
      { id: 'priority', label: 'Priority', type: 'select', options: ['Critical', 'High', 'Medium', 'Low'] },
      { id: 'createdDate', label: 'Create Date', type: 'date' },
      { id: 'ownerAssignedDate', label: 'Lead Assigned Date', type: 'date' },
      { id: 'lastActivityDate', label: 'Last Activity Date', type: 'date' },
      { id: 'daysStalled', label: 'Days Stalled', type: 'number' },
      { id: 'ownerName', label: 'Owner (Agent)', type: 'text' }
    ]
  },
  'default': {
    title: 'General',
    filters: [
      { id: 'createdAt', label: 'Created At', type: 'date' },
      { id: 'status', label: 'Status', type: 'text' }
    ]
  }
};

export const getFiltersForPage = (pageId) => {
  return FILTER_REGISTRY[pageId] || FILTER_REGISTRY['default'];
};
